"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function InvoiceTemplateSvg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("rect", { width: 20, height: 20, rx: 2, fill: "#DEE5FF" }),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 5C12 4.44772 12.4477 4 13 4C13.5523 4 14 4.44772 14 5V6.0389C15.0483 6.14905 16.0827 6.48852 16.8277 6.99815L16.0239 8.56932C15.1244 8.03327 13.9952 7.70055 13.0957 7.70055C12.2344 7.70055 11.6029 7.97782 11.6029 8.68022C11.6029 9.4336 12.5397 9.7042 13.6328 10.0199C15.1679 10.4633 17.0111 10.9957 16.9999 13.0795C16.9999 14.7916 15.6594 15.7028 14 15.938V17C14 17.5523 13.5523 18 13 18C12.4477 18 12 17.5523 12 17V15.9159C10.8647 15.7424 9.76785 15.3038 9 14.6322L9.78468 13.1165C10.6651 13.8743 12.0813 14.3364 13.1914 14.3364C14.1292 14.3364 14.8564 14.0222 14.8564 13.2828C14.8564 12.4174 13.8678 12.1318 12.7414 11.8062C11.2452 11.3739 9.50582 10.8712 9.51674 8.84658C9.51674 7.29657 10.6013 6.43745 12 6.13079V5Z", fill: "#8AA4FF" }),
        react_1.default.createElement("rect", { x: 3, y: 3, width: 6, height: 2, fill: "#8AA4FF" }),
        react_1.default.createElement("rect", { x: 3, y: 7, width: 5, height: 2, fill: "#8AA4FF" }),
        react_1.default.createElement("rect", { x: 3, y: 11, width: 4, height: 2, fill: "#8AA4FF" }));
}
function InvoiceTemplate(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(InvoiceTemplateSvg, Object.assign({}, svgProps)));
}
exports.default = InvoiceTemplate;
//# sourceMappingURL=InvoiceTemplate.js.map